import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { BrandBriefPopup } from './BrandBriefPopup';

export const BRAND_BRIEF_POPUP = Symbol('BRAND_BRIEF');

export const useBrandBriefPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(BRAND_BRIEF_POPUP, BrandBriefPopup);
  });

  return useCallback(
    ({ brandBrief, brandVoice }) => {
      return new Promise((resolve) => {
        popups.openPopup(BRAND_BRIEF_POPUP, {
          brandBrief,
          brandVoice,
          onClose: (result) => {
            popups.closePopup(BRAND_BRIEF_POPUP);
            resolve(result);
          },
        });
      });
    },
    [popups]
  );
};
